import { format } from 'date-fns'
import { configApi } from '../http-client.js'
import { DATE_FORMAT } from '../../utils/date-formatting.js'

export const getPrivacyPolicies = () => {
	return configApi.get(`/api/PrivacyPolicies`)
}

export const getActivePrivacyPolicies = () => {
	return configApi.get(`/api/PrivacyPolicies`).then(({ data }) => ({
		data: data.map(privacyPolicy => {
			const activeVersion = privacyPolicy.versions.find(({ isActive }) => isActive)
			return {
				brandId: privacyPolicy.brandId,
				brandName: privacyPolicy.brandName,
				isGlobalDefault: privacyPolicy.isGlobalDefault,
				isVisibleInCSPortal: privacyPolicy.isVisibleInCSPortal,
				isInternal: privacyPolicy.isInternal,
				privacyPolicyId: privacyPolicy.privacyPolicyId,
				value: privacyPolicy.privacyPolicyId,
				text: activeVersion?.policyName,
				privacyPolicyName: activeVersion?.policyName,
				privacyPolicyUrl: activeVersion?.policyUrl ?? null,
				externalVersionRef: activeVersion?.externalVersionRef,
				activeVersionId: activeVersion?.versionId,
				createdDate: activeVersion?.createdDate ? format(new Date(activeVersion.createdDate), DATE_FORMAT) : null
			}
		})
	}))
}

export const deletePrivacyPolicy = privacyPolicyId => {
	return configApi.delete(`/api/PrivacyPolicies?PrivacyPolicyId=${privacyPolicyId}`)
}

export const postPrivacyPolicy = privacyPolicy => {
	return configApi.post(`/api/PrivacyPolicies`, privacyPolicy)
}

export const putPrivacyPolicy = privacyPolicy => {
	if (privacyPolicy.privacyPolicyId) {
		delete privacyPolicy.brandId
		delete privacyPolicy.brandName
	}
	return configApi.put(`/api/PrivacyPolicies`, privacyPolicy)
}

export const setGlobalDefaultPrivacyPolicy = privacyPolicyId => {
	return configApi.put(`/api/PrivacyPolicies/SetGlobalDefault`, privacyPolicyId)
}
